export default "__VITE_ASSET__DfPabcu1__"